import { ButtonTertiary } from "@nova/component-btn"
import { Dropdown } from "@nova/component-dropdown"
import { ButtonSplit } from "@nova/ds-component-button-split"
import * as Icons from "@nova/component-icons"
import { InputOutlined } from "@nova/ds-component-input"
import { ScrollableArea } from "@nova/component-scrollable-area"
import { useMemo, useState } from "react"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"
import { PilotFilterValue } from "./PilotFilter"
import classNames from "classnames"

interface SubmitterFilterProps {
    users: PilotFilterValue[]
    value: PilotFilterValue | undefined
    onChange: (value: PilotFilterValue | undefined) => void
}

export const SubmitterFilter = ({ users, value, onChange }: SubmitterFilterProps) => {
    const [search, setSearch] = useState("")

    const filtered = useMemo(
        () =>
            !!users?.length
                ? users.filter((u) => u.name.toLowerCase().includes(search.toLowerCase()))
                : [],
        [users, search]
    )

    return (
        <Dropdown>
            <Dropdown.Trigger as="div" className="group">
                {value ? (
                    <ButtonSplit
                        label={value.name}
                        onRightClick={(e) => {
                            e.stopPropagation()
                            onChange(undefined)
                        }}
                    />
                ) : (
                    <ButtonTertiary
                        title="People"
                        RightIcon={Icons.ArrowDropdown}
                        rightIconClassName="transition-transform group-data-[state=open]:rotate-180"
                        className="group-data-[state=open]:!border-gray-300 group-data-[state=open]:!text-gray-0"
                    />
                )}
            </Dropdown.Trigger>
            <Dropdown.Menu className="w-[300px]">
                <div className="p-3 pb-2 text-gray-100">
                    <InputOutlined
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        placeholder="Search"
                        leftItem={<Icons.Icon Icon={Icons.MagnifyingGlass} className="mr-1" />}
                        autoFocus
                    />
                </div>
                <ScrollableArea className="max-h-[300px] pb-2">
                    {filtered.map((user) => (
                        <Dropdown.ButtonItem
                            key={user.id}
                            onClick={() => onChange(user)}
                            className={classNames("flex items-center gap-3", {
                                "bg-white-200": value?.id === user.id,
                            })}
                        >
                            <div className="w-8 min-w-[32px] aspect-square rounded-lg overflow-hidden">
                                <ProfilePhoto userId={user.id} fullName={user.name} />
                            </div>
                            <span className="text-sm text-white">{user.name}</span>
                        </Dropdown.ButtonItem>
                    ))}
                </ScrollableArea>
            </Dropdown.Menu>
        </Dropdown>
    )
}
